/* ----------------------------------------
 * Event form handling (async Kirby form)
 * ----------------------------------------
 */

const eventsForm = document.getElementById('eventsform');

if (eventsForm !== null) {

  /************************************************************************
   * Dates Inputs
   ************************************************************************/

  const assignUniqueNames = function(row) {
    const id = Math.random().toString(36).substring(2, 10);
    row.dataset.id = `date-${id}`;

    row.querySelectorAll('input').forEach(input => {
      let name  = input.getAttribute('data-name')  || '';
      let field = input.getAttribute('data-field') || '';
      input.setAttribute('name', `${name}[][${id}][${field}]`);
      input.setAttribute('data-id', `${name}-${id}-${field}`);
    });
  };



  const attachAddDeleteListeners = function(row) {
    const addBtn = row.querySelector('[data-add-button]');
    const deleteBtn = row.querySelector('[data-delete-button]');

    // Add row button
    addBtn.addEventListener('click', (e) => {
      e.preventDefault();
      const cur = row;
      const nextRow = cur.cloneNode(true);
      cur.insertAdjacentElement('afterend', nextRow);

      // Clear all inputs
      nextRow.querySelectorAll('input').forEach(input => {
        if (input.type === 'checkbox') input.checked = input.defaultChecked;
        else input.value = '';
      });

      assignUniqueNames(nextRow);

      // Recursiv add listeners
      attachAddDeleteListeners(nextRow);
    });

    deleteBtn.addEventListener('click', (e) => {
      e.preventDefault();
      row.remove();
    });
  };


  eventsForm.querySelectorAll('[data-template="date-row"]').forEach(row => {
    assignUniqueNames(row);
  });


  eventsForm.querySelectorAll('[data-add-button]').forEach(button => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      const currentRow = button.closest('[data-template="date-row"]');
      const newRow = currentRow.cloneNode(true);
      const deleteBtn = newRow.querySelector('[data-delete-button]');

      newRow.querySelectorAll('input').forEach(input => {
        if (input.type === 'checkbox') input.checked = input.defaultChecked;
        else input.value = '';
      });

      deleteBtn.disabled = false;
      
      assignUniqueNames(newRow);

      currentRow.insertAdjacentElement('afterend', newRow);
      attachAddDeleteListeners(newRow);
    })
  });

  
  

  /************************************************************************
   * Toggle Switches
   ************************************************************************/

  eventsForm.querySelectorAll('[data-toggle]').forEach(el => {
    el.addEventListener('click', (e) => {
      const selector = el.getAttribute('data-toggle');
      const targets = eventsForm.querySelectorAll(selector);
      if (!targets) return;

      targets.forEach(target => {
        // Toggle hidden attribute
        const isHidden = target.hasAttribute('hidden');
        if (isHidden) {
          target.removeAttribute('hidden');
          target.setAttribute('aria-hidden', 'false');
        } else {
          target.setAttribute('hidden', '');
          target.setAttribute('aria-hidden', 'true');
        }
      });

    });
  });


  /************************************************************************
   * Dropdowns with checkboxes
   ************************************************************************/

  eventsForm.querySelectorAll('details.dropdown').forEach(dropdown => {
    const summary = dropdown.querySelector('summary');
    const checkboxes = dropdown.querySelectorAll('input[type="checkbox"]');
    const baseText = summary.textContent.replace(/\s*\(\d+\)$/, '').trim();
    const updateSummary = () => {
      const checkedCount = Array.from(checkboxes).filter(cb => cb.checked).length;
      summary.textContent = `${baseText} (${checkedCount})`;
    };
    updateSummary();
    checkboxes.forEach(cb => cb.addEventListener('change', updateSummary));
  });


  /************************************************************************
   * Form SUBMIT Actions
   ************************************************************************/

  eventsForm.addEventListener('submit', async (e) => {
    e.preventDefault();

    // Collect references to relevant elements
    const submitBtn     = eventsForm.querySelector('button[type="submit"]');
    const dialog        = eventsForm.querySelector('[data-dialog]');
    const output        = eventsForm.querySelector('[data-message]');
    const dialogTitle   = dialog?.querySelector('[data-dialog-title]');
    const dialogMessage = dialog?.querySelector('[data-dialog-message]');
    const dialogButton  = dialog?.querySelector('[data-dialog-button]');

    // Attach close handler to dialog button
    if (dialogButton !== null) {
      dialogButton.addEventListener('click', (e) => {
        e.preventDefault();
        window.location.reload();
      });
    }

    // Indicate busy state while request is running
    submitBtn?.setAttribute('aria-busy', 'true');

    try {

      // Send form data to the Kirby controller (async)
      const res  = await fetch(e.target.action, {
        method: 'POST',
        body: new FormData(e.target)
      });

      const json = await res.json();

      // Remove old outputs
      if(output !== null) {
        output.innerHTML = '';
        output.hidden = true;
      }

      // Successful response
      if (json.status === 'ok' || json.status === 'warning') {
        dialog.setAttribute('open', '');
        dialogMessage.textContent = json.message;
        dialogTitle.textContent   = json.details.title;
        // console.log(json);
        if(json.status === 'warning') console.warn(json.message);
        
      }
      
      // Handle error responses
      else if (json.status === 'error') {
        
        // Abort on security errors (CSRF, honeypot, timing)
        if (
          json.code === 'error.event.form.csrf' ||
          json.code === 'error.event.form.honeypot' ||
          json.code === 'error.event.form.timing'
        ) {
          console.warn('Form aborted for security reasons.');
        }

        // Handle validation and date errors (invalid input fields)
        else if (json.code === 'error.event.form.validation' || json.code === 'error.event.form.dates') {
          
          // Remove existing invalid markers
          eventsForm.querySelectorAll('[aria-invalid="true"]').forEach(el => {
            el.removeAttribute('aria-invalid');
          });

          // Highlight fields returned as invalid
          if (Array.isArray(json.details.errors)) {
            json.details.errors.forEach(name => {
              const input = document.querySelector(`[data-id="${name}"]`);
              if (input) {
                input.setAttribute('aria-invalid', 'true');
                
                const details = input.closest(`[data-details]`);
                
                if(details) {
                  details.setAttribute('open', 'open');
                }
                
              } 
            });
          }

          // Show the message
          if(output !== null) {
            output.innerHTML = (json.details.title !== null) ? `<b>${json.details.title}</b> ${json.message}` : json.message;
            output.hidden = false;
          }

          console.warn(json.message);
        }
      }

      // Handle unexpected response format
      else {
        console.warn(json.message);
      }
    }

    catch (err) {
      // Network or parsing failure
      console.error('Form request failed:', err);
    }

    finally {
      // Always reset the busy state
      submitBtn?.setAttribute('aria-busy', 'false');
    }
  });
}
